import {
  ElementProps,
  MenuItemProps,
  Menu as RawMenu,
  UnstyledButton,
} from '@mantine/core';
import colors, { ColorVariantType } from 'common/constants/colors.styles';
import React from 'react';
import { PredefinedFirst } from 'types/helper.type';

import Text, { TextProps } from './text';

export type MenuDataType = {
  color?: PredefinedFirst<ColorVariantType>;
  label?: string;
  isHidden?: boolean;
} & Omit<MenuItemProps, 'color'> &
  Omit<ElementProps<'button', keyof MenuItemProps>, 'type'>;

export interface MenuProps extends React.ComponentProps<typeof RawMenu> {
  data: MenuDataType[];
  target: React.ReactNode;
  textProps?: TextProps;
}

export default function Menu(props: MenuProps) {
  const { data, target, textProps, ...rest } = props;

  const items = React.useMemo(() => {
    return data.filter((item) => item.isHidden !== true);
  }, [data]);

  if (items.length === 0) return null;

  return (
    <RawMenu {...rest}>
      <RawMenu.Target>
        <UnstyledButton>{target}</UnstyledButton>
      </RawMenu.Target>
      <RawMenu.Dropdown>
        {items.map((item, index) => {
          return (
            <RawMenu.Item
              key={index}
              {...item}
              color={
                typeof item.color === 'string'
                  ? colors[item.color] || item.color
                  : item.color
              }
            >
              {item.label && (
                <Text color={item.color} variant="button3" {...textProps}>
                  {item.label}
                </Text>
              )}
            </RawMenu.Item>
          );
        })}
      </RawMenu.Dropdown>
    </RawMenu>
  );
}
